import { Skeleton, Stack } from '@mui/material';

import useLoadAgentImage from '../../../hooks/useLoadAgentImage';
import { useTranslation } from '../../../hooks/useTranslation';
import { AgentMetricsUnit, AgentVoice } from '../../../interfaces/Agent';
import StyledAgentImage from '../../../styles/StyledAgentImage';
import AgentMetric from '../AgentMetric/AgentMetric';
import TextTruncated from '../TextTruncated/TextTruncated';
import StyledAgentName from './StyledAgentName';

interface AgentTopThreeProps {
  agentName: string;
  image: string;
  duration: number;
  calls: number;
  successRate: number;
  voice: AgentVoice;
}

const AgentTopThree: React.FC<AgentTopThreeProps> = ({
  agentName,
  image,
  duration,
  calls,
  successRate,
  voice,
}) => {
  const { imgSrc } = useLoadAgentImage(image, voice);
  const { t } = useTranslation();

  return (
    <Stack direction="row" gap="1rem" width="400px">
      {imgSrc ? (
        <StyledAgentImage
          src={imgSrc ?? ''}
          alt={t('An image of an agent.')}
          width="200px"
        />
      ) : (
        <Stack>
          <Skeleton
            data-testid="agent-image-skeleton"
            variant="rounded"
            width="228px"
            height="228px"
          />
        </Stack>
      )}
      <Stack direction="column" gap="1rem" sx={{ width: '40%' }}>
        <StyledAgentName>
          <TextTruncated title={agentName}>{agentName}</TextTruncated>
        </StyledAgentName>
        <AgentMetric
          unit={AgentMetricsUnit.MINUTE}
          value={duration}
          label={t('Duration')}
        />
        <AgentMetric value={calls} label={t('Calls')} />
        <AgentMetric
          unit={AgentMetricsUnit.PERCENT}
          value={successRate}
          label={t('Success Rate')}
        />
      </Stack>
    </Stack>
  );
};

export default AgentTopThree;
